import React from "react";
import CloseIcon from "@material-ui/icons/Close";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import SearchIcon from "@material-ui/icons/Search";
import SortIcon from "@material-ui/icons/Sort";

type HeaderProps = {
  header: string;
  close?: boolean;
  controls?: boolean;
  closeClick?: any;
  backClick?: any;
  searchClick?: any;
  sortClick?: any;
};

export const ModalSliderHeader = ({ ...props }: HeaderProps) => {
  return (
    <div className="modal-slider-header">
      <div className="start-icons">
        {props.close ? (
          <CloseIcon onClick={props.closeClick} />
        ) : (
          <KeyboardBackspaceIcon onClick={props.backClick} />
        )}
      </div>
      <div className="font-weight-bold modal-slider-header-text">
        {props.header}
      </div>
      <div className="control-icons">
        {props.controls ? (
          <span>
            <SearchIcon onClick={props.searchClick} className="search-icon" />
            <SortIcon onClick={props.sortClick} className="sort-icon" />
          </span>
        ) : null}
      </div>
    </div>
  );
};
